/****************************************************
 * Module Name:  editCustomerModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import UserProxy from "../../utility/proxy/manager/userProxy";
import Select from "react-select";
import LocationProxy from "../../utility/proxy/manager/locationProxy";
import "bootstrap/dist/css/bootstrap.min.css";
import DesignationProxy from "../../utility/proxy/manager/designationProxy";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { MultiSelect } from "../common/reactSelectWithSelectAll";
import CustomerProxy from "../../utility/proxy/manager/customerProxy";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';
import SettingsProxy from "../../utility/proxy/manager/settingsProxy";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";

const setPropSourceDataofBroker = (dataToMap) => {
  let newArr = [];
  dataToMap.map((item) => {
    let option = { value: item.brokerid, label: item.username };
    newArr.push(option);
    return true;
  });
  return newArr;
};

const fullOptionToBrokerValue = (customerId, selectedData) => {
  let customerid = customerId;
  let newArr = [];
  selectedData.map((option) => {
    newArr.push({ customerid, brokerid: option.value });
    return true;
  });
  return newArr.includes("*") ? [] : newArr;
};

export default class EditCustomerModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newcompanyname: this.props.editOperation
        ? this.props.sourceData.companyname
        : "",
      newusername: this.props.editOperation
        ? this.props.sourceData.username
        : "",
      newUserType:
        this.props.sourceData !== undefined
          ? this.props.editOperation ||
            (!this.props.editOperation && this.props.sourceData.usertype)
            ? {
              value: this.props.sourceData.usertype,
              label: this.props.sourceData.usertype,
            }
            : { value: 0, label: "Error" }
          : { value: 0, label: "Error" },
      newfirst_name: this.props.editOperation
        ? this.props.sourceData.first_name
        : "",
      newmiddle_name: this.props.editOperation
        ? this.props.sourceData.middle_name
        : "",
      newlast_name: this.props.editOperation
        ? this.props.sourceData.last_name
        : "",
      newdesignation: this.props.editOperation
        ? this.props.sourceData.designation
        : "",
      newemployeeid: this.props.editOperation
        ? this.props.sourceData.employeeid
        : "",
      newlocationid: this.props.editOperation
        ? this.props.sourceData.locationid
        : "",
      newfullLocation: this.props.editOperation
        ? {
          value: this.props.sourceData.locationid,
          label:
            this.props.sourceData.location +
            " | " +
            this.props.sourceData.country,
        }
        : { value: 0, label: "Error" },

      newAssignedEmployee: this.props.editOperation
        ? {
          value:
            this.props.sourceData.employecustomer.length === 0
              ? ""
              : this.props.sourceData.employecustomer[0].employeid,
          label:
            this.props.sourceData.employecustomer.length === 0
              ? ""
              : this.props.sourceData.employecustomer[0].username,
        }
        : "",
      newAssignedBroker: this.props.editOperation
        ? setPropSourceDataofBroker(this.props.sourceData.brokercustomer)
        : "",
      newdeleted: this.props.editOperation
        ? this.props.sourceData.deleted
        : false,
      newdisabled: this.props.editOperation
        ? this.props.sourceData.disabled
        : false,
      newDiscount: this.props.editOperation
        ? this.props.sourceData.discount
          ? this.props.sourceData.discount
          : "0.0"
        : "0.0",
      newLabgrownDiscount: this.props.editOperation
        ? this.props.sourceData.labgrowndiscount
          ? this.props.sourceData.labgrowndiscount
          : "0.0"
        : "0.0",
      newLabGrownCommission: this.props.editOperation
        ? this.props.sourceData.labgrowncommission
          ? this.props.sourceData.labgrowncommission
          : "0.0"
        : "0.0",
      newGstNo: this.props.editOperation
        ? this.props.sourceData.gstinno
          ? this.props.sourceData.gstinno
          : ""
        : "",
      newPanNo: this.props.editOperation
        ? this.props.sourceData.panno
          ? this.props.sourceData.panno
          : ""
        : "",
      newspecialuser: this.props.editOperation
        ? this.props.sourceData.specialuser
        : false,
      newgrade: this.props.editOperation
        ? this.props.sourceData.grade
        : "",
      newEmail: this.props.editOperation ? this.props.sourceData.email : "",
      newPhone: this.props.editOperation ? this.props.sourceData.phone : "",
      newCreated: this.props.editOperation ? this.props.sourceData.created : "",
      newCreatedBy: this.props.editOperation ? this.props.sourceData.createdby : Constants.loggedInUser.username,
      showError: false,
      discountPremiumLimit: "0.0",
      discountPremiumError: false,
      labgrownDiscountPremiumError: "",
      discountLimit: "0.0",
      discountError: "",
      labgrownDiscountError: "",
      validateUserPresentSpinner: false,
      showValidationMessage: false,
      userNameAvailable: true,
      discountValidationError: "",
      labgrownDiscountValidationError: "",
      fullLocation: [],
      fullLocationOptions: [],
      showLocationLoadSpinner: false,

      employeeOptions: [],
      showEmployeeLoadSpinner: true,

      brokerOptions: [],
      showBrokerLoadSpinner: true,

      allUserType: [],

      designationOptions: [],
      showDesignationLoadSpinner: true,

      userNameValidationError: "",
      firstNameValidationError: "",
      newPanNoValidationError: "",

      showUserDetailModal: false,
      userDetailContext: ""
    };
    this.getAllLocationList(false);
    this.getAllDesignationList(false);
    this.getAllEmployee(false);
    this.getAllBroker(false);
    this.getAllSettingKeys();
    if (this.props.sourceData === undefined) {
      this.getUserById();
    }
  }

  getAllSettingKeys = () => {
    let optionsArray = [];
    optionsArray.push("MAX_CUSTOMER_DISCOUNT");
    optionsArray.push("MAX_CUSTOMER_PREMIUM");
    optionsArray.push("MAX_BROKER_COMMISSION");
    optionsArray.push("MIN_BROKER_COMMISSION");

    SettingsProxy.GetSettingsByName(optionsArray, (response) =>
      this.setState({
        discountTypes: response,
        settingKeys: optionsArray,
      })
    );
  };

  setDiscountError = (e, type) => {
    if (
      !e.target.value.length ||
      e.target.value === undefined ||
      e.target.value === null
    ) {
      return "";
    }
    if (type === "natural") {
      if (Utility.CheckisNumberPositive(parseFloat(e.target.value))) {
        if (parseFloat(e.target.value) > parseFloat(this.state.discountPremiumLimit)) {
          return this.state.discountPremiumError;
        }
      }

      if (Utility.CheckisNumberNegative(parseFloat(e.target.value))) {
        if (parseFloat(e.target.value) < parseFloat(this.state.discountLimit)) {
          return this.state.discountError;
        }
      }
    } else if (type === "labgrown") {
      if (Utility.CheckisNumberPositive(parseFloat(e.target.value))) {
        if (parseFloat(e.target.value) > parseFloat(this.state.discountPremiumLimit)) {
          return this.state.labgrownDiscountPremiumError;
        }
      }

      if (Utility.CheckisNumberNegative(parseFloat(e.target.value))) {
        if (parseFloat(e.target.value) < parseFloat(this.state.discountLimit)) {
          return this.state.labgrownDiscountError;
        }
      }
    }
    return "";
  };


  getUserById = () => {
    CustomerProxy.GetSingleCustomerById(this.props.userId, (response) =>
      this.setState({
        newcompanyname: response.companyname,
        newusername: response.username,
        newUserType: { value: response.usertype, label: response.usertype },
        newfirst_name: response.first_name,
        newmiddle_name: response.middle_name,
        newlast_name: response.last_name,
        newdesignation: response.designation,
        newemployeeid: response.employeeid,
        newlocationid: response.locationid,
        newspecialuser: response.specialuser,
        newgrade: response.grade,
        newfullLocation: {
          value: response.locationid,
          label: response.location + " | " + response.country,
        },
        newAssignedEmployee: {
          value:
            response.employecustomer.length === 0
              ? ""
              : response.employecustomer[0].employeid,
          label:
            response.employecustomer.length === 0
              ? ""
              : response.employecustomer[0].username,
        },
        newAssignedBroker: setPropSourceDataofBroker(response.brokercustomer),
        newdeleted: response.deleted,
        newdisabled: response.disabled,
        newDiscount: response.discount,
        newLabGrownDiscount: response.labgrowndiscount,
        newLabGrownCommission: response.labgrowncommission,
        newEmail: response.email,
        newPhone: response.phone,
        newPanNo: response.panno,
        newGstNo: response.gstinno,
        newCreated: response.created,
        newCreatedBy: response.createdby,
      })
    );
  };

  getAllEmployee = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showEmployeeLoadSpinner: true });
    UserProxy.GetAllEmployeeMini("", (response) =>
      this.setAllEmployeeData(response)
    );
  };

  setAllEmployeeData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = { value: data.id, label: data.username };
      optionsArray.push(option);

      return true;
    });
    this.setState({
      employeeOptions: optionsArray,
      newAssignedEmployee:
        this.state.newAssignedEmployee === "" && optionsArray.length > 0
          ? optionsArray[0].value
          : this.state.newAssignedEmployee,
      showEmployeeLoadSpinner: false,
    });
  };
  getAllBroker = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showBrokerLoadSpinner: true });
    UserProxy.GetAllBrokerMini((response) =>
      this.setAllBrokerData(response)
    );
  };

  setAllBrokerData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = { value: data.id, label: data.username };
      optionsArray.push(option);

      return true;
    });
    this.setState({
      brokerOptions: optionsArray,
      newAssignedBroker:
        this.state.newAssignedBroker === "" && optionsArray.length > 0
          ? optionsArray[0].value
          : this.state.newAssignedBroker,
      showBrokerLoadSpinner: false,
    });
  };

  getAllLocationList = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showLocationLoadSpinner: true });
    LocationProxy.GetAllLocationDetail((response) =>
      this.setAllLocationData(response)
    );
  };

  setAllLocationData = (response) => {
    this.setAllUserType();
    let cOptions = [];
    let nnewfullLocation = this.state.newfullLocation;
    response.map((data) => {
      let iOption = { value: data.id, label: data.name + " | " + data.country };
      cOptions.push(iOption);

      if (data.id === this.state.newfullLocation.value)
        nnewfullLocation = iOption;
      return true;
    });

    //During new creation option select first one as default
    if (nnewfullLocation.value === 0 && cOptions.length > 0)
      nnewfullLocation = cOptions[0];

    this.setState({
      fullLocation: response,
      fullLocationOptions: cOptions,
      newfullLocation: nnewfullLocation,
      showLocationLoadSpinner: false,
    });
  };

  setAllUserType = () => {
    let optionsArray = [];
    Object.keys(Constants.USER_TYPE).map((key) => {
      let option = { value: key, label: Constants.USER_TYPE[key] };
      optionsArray.push(option);
      return true;
    });
    this.setState({
      allUserType: optionsArray,
      newUserType:
        this.state.newUserType.value === 0 && optionsArray.length > 0
          ? optionsArray[0]
          : this.state.newUserType,
    });
  };

  getAllDesignationList = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showDesignationLoadSpinner: true });
    DesignationProxy.GetAllDesignation((response) =>
      this.setAllDesigationData(response)
    );
  };

  setAllDesigationData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = { value: data.name, label: data.name };
      optionsArray.push(option);

      return true;
    });
    this.setState({
      designationOptions: optionsArray,
      newdesignation:
        this.state.newdesignation === "" && optionsArray.length > 0
          ? optionsArray[0].value
          : this.state.newdesignation,
      showDesignationLoadSpinner: false,
    });
  };

  handleSave = () => {
    let customerId =
      this.props.sourceData === undefined
        ? this.props.userId
        : this.props.sourceData.id;
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      companyname: this.state.newcompanyname.trim(),
      username: this.state.newusername,
      first_name: this.state.newfirst_name,
      middle_name: this.state.newmiddle_name,
      last_name: this.state.newlast_name,
      designation: this.state.newdesignation,
      employeeid: this.state.newemployeeid,
      employecustomer: this.state.newAssignedEmployee && this.state.newAssignedEmployee.value
        ? [
          {
            customerid: customerId,
            employeid: this.state.newAssignedEmployee.value,
          },
        ]
        : [],
      brokercustomer: fullOptionToBrokerValue(
        customerId,
        this.state.newAssignedBroker
      ),
      locationid: this.state.newfullLocation.value,
      deleted: this.state.newdeleted,
      disabled: this.state.newdisabled,
      specialuser: this.state.newspecialuser,
      grade: this.state.newgrade,
      discount: this.state.newDiscount,
      labgrowncommission: this.state.newLabGrownCommission,
      labgrowndiscount: this.state.newLabgrownDiscount,
      gstinno: this.state.newGstNo,
      panno: this.state.newPanNo,
      usertype: this.state.newUserType.value,
      email: this.state.newEmail,
      phone: this.state.newPhone,
      created: this.state.newCreated,
      createdby: this.state.newCreatedBy,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(customerId, data))
          this.props.handleSave(customerId, data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(customerId, data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  buttonDisable = () => {
    if (this.props.editOperation && !this.state.newfirst_name)
      return true;

    if (
      this.props.sourceData === undefined &&
      this.state.newfirst_name.length === 0
    )
      return true;

    if (this.state.newPanNo === "" && this.state.newPanNoValidationError.length > 0) return true;

    if (this.state.discountValidationError.length > 0 || this.state.labgrownDiscountValidationError.length > 0) return true;

    return false;
  };

  userTypeChangeHandler = (selectedOption, type) => {
    const limits = {
      C: {
        MAX: "MAX_CUSTOMER_DISCOUNT",
        MIN: "MAX_CUSTOMER_PREMIUM",
      },
      BROKER: {
        MAX: "MAX_BROKER_COMMISSION",
        MIN: "MIN_BROKER_COMMISSION",
      }
    };

    const { MAX, MIN } = limits[selectedOption.label] || {};

    let MIN_MAX_LIMIT = [];
    if (MAX && MIN && this.state.settingKeys.includes(MAX) && this.state.settingKeys.includes(MIN)) {
      MIN_MAX_LIMIT = this.state.discountTypes.filter(iTypes =>
        iTypes.settingkey === MAX || iTypes.settingkey === MIN
      );
    }

    const getLimitValue = (key) => {
      const limit = MIN_MAX_LIMIT.find(iTypes => iTypes.settingkey === key);
      return limit ? limit.settingvalue : "0.0";
    };

    const MAX_LIMIT_VALUE = getLimitValue(MAX);
    const MIN_LIMIT_VALUE = getLimitValue(MIN);

    const naturalCommonState = {
      newUserType: selectedOption,
      newDiscount: "0.0",
      discountValidationError: "",
    };

    const labgrownCommonState = {
      newUserType: selectedOption,
      newLabGrownDiscount: "0.0",
      labgrownDiscountValidationError: "",
    };

    if (type === "natural") {
      this.setState({
        ...naturalCommonState,
        discountPremiumLimit: MIN_LIMIT_VALUE,
        discountLimit: MAX_LIMIT_VALUE,
        discountPremiumError: `You are not allowed to have a premium of more than ${MIN_LIMIT_VALUE}`,
        discountError: `You are not allowed to have a discount of less than ${MAX_LIMIT_VALUE}`
      });
    } else if (type === "labgrown") {
      this.setState({
        ...labgrownCommonState,
        discountPremiumLimit: MIN_LIMIT_VALUE,
        discountLimit: MAX_LIMIT_VALUE,
        labgrownDiscountPremiumError: `You are not allowed to have a premium of more than ${MIN_LIMIT_VALUE}`,
        labgrownDiscountError: `You are not allowed to have a discount of less than ${MAX_LIMIT_VALUE}`
      });
    }
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add customer validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        {this.state.showUserDetailModal && (
          <>
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                backdropFilter: "blur(1px)",
                zIndex: 1299,
              }}
            />
            <UserDetailModal
              show={true}
              handleClose={() => this.setState({ showUserDetailModal: false })}
              handleSelect={(selectedOption) => {
                if (this.state.userDetailContext === "E") {
                  const selectedData = this.state.employeeOptions.filter(opt => selectedOption.includes(opt.value));
                  this.setState({
                    userDetailContext: "",
                    showUserDetailModal: false,
                    newAssignedEmployee: selectedData[0],
                  });
                } else if (this.state.userDetailContext === "B") {
                  const selectedData = this.state.brokerOptions.filter(opt => selectedOption.includes(opt.value));
                  this.setState({
                    userDetailContext: "",
                    showUserDetailModal: false,
                    newAssignedBroker: selectedData,
                  });
                }
              }}
              userids={this.state.userDetailContext === "E" ?
                (this.state.employeeOptions.filter(opt => opt.value !== "*")).map(cust => cust.value) :
                (this.state.brokerOptions.filter(opt => opt.value !== "*")).map(cust => cust.value)}
              selectedIds={
                this.state.userDetailContext === "E"
                  ? this.state.newAssignedEmployee !== "" ? [this.state.newAssignedEmployee.value] : []
                  : this.state.newAssignedBroker.length > 0 ? this.state.newAssignedBroker.map(i => i.value) : []
              }
              usertype={this.state.userDetailContext}
              loading={this.state.showUserDetailModal}
              isMulti={this.state.userDetailContext === "B" ? true : false}
            />
          </>
        )}

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} size="lg" enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;Edit Customer
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Box
              sx={{
                width: "100%",
                "& .css-2vawn2-MuiTypography-root": {
                  alignSelf: "center",
                },
              }}
            >
              {this.props.editOperation && (
                <Box sx={{ display: "flex", width: "100%" }}>
                  <Typography sx={{ width: "24%" }}>User Id</Typography>
                  <Typography sx={{ fontWeight: "bold" }}>
                    {this.props.sourceData.id}
                  </Typography>
                </Box>
              )}
              {!this.props.sourceData && (
                <Box sx={{ display: "flex", width: "100%" }}>
                  <Typography sx={{ width: "24%" }}>User Id</Typography>
                  <Typography sx={{ fontWeight: "bold" }}>
                    {this.props.userId}
                  </Typography>
                </Box>
              )}
              <Box sx={{ display: "flex", mt: 1 }}>
                <Typography sx={{ width: "24%" }}>Username</Typography>
                <Typography sx={{ fontWeight: "bold" }}>
                  {this.state.newusername}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography sx={{ width: "30%" }}>
                  First Name <sup style={{ color: "red" }}>*</sup>
                </Typography>
                <TextField
                  margin="normal"
                  size="small"
                  fullWidth
                  label="First Name (required)"
                  placeholder="Enter First Name"
                  value={this.state.newfirst_name}
                  onChange={(e) =>
                    this.setState({
                      newfirst_name: e.target.value.trim(),
                      firstNameValidationError: Utility.CheckIsPresent(
                        e.target.value
                      )
                        ? ""
                        : "First Name Cannot be Empty ",
                    })
                  }
                  helperText={this.state.firstNameValidationError}
                  error={this.state.firstNameValidationError.length > 0}
                />
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ width: "30%" }}>Middle Name</Typography>
                <TextField
                  margin="normal"
                  size="small"
                  fullWidth
                  label="Middle Name"
                  placeholder="Enter Middle Name"
                  value={this.state.newmiddle_name}
                  onChange={(e) =>
                    this.setState({ newmiddle_name: e.target.value.trim() })
                  }
                />
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ width: "30%" }}>Last Name</Typography>
                <TextField
                  margin="normal"
                  size="small"
                  fullWidth
                  label="Last Name"
                  placeholder="Enter Last Name"
                  value={this.state.newlast_name}
                  onChange={(e) =>
                    this.setState({ newlast_name: e.target.value.trim() })
                  }
                />
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ width: "30%" }}>Company Name</Typography>
                <TextField
                  margin="normal"
                  size="small"
                  fullWidth
                  label="Company Name"
                  placeholder="Enter Company Name"
                  value={this.state.newcompanyname}
                  onChange={(e) =>
                    this.setState({ newcompanyname: e.target.value })
                  }
                />
              </Box>
              <Box sx={{ display: "flex", mt: 1 }}>
                <Typography sx={{ width: "30%" }}>Employee Id</Typography>
                <TextField
                  size="small"
                  fullWidth
                  label="Employee Id"
                  placeholder="Enter Employee Id"
                  value={this.state.newemployeeid}
                  onChange={(e) =>
                    this.setState({ newemployeeid: e.target.value })
                  }
                />
              </Box>
              <Box sx={{ display: "flex", mt: 1 }}>
                <Typography sx={{ width: "23%", alignSelf: "center" }}>
                  User Type
                </Typography>
                <Typography sx={{ fontWeight: "600" }}>
                  {Constants.USER_TYPE[this.state.newUserType.value]}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", mt: 1 }}>
                <Typography sx={{ width: "23%", alignSelf: "center" }}>
                  Designation
                </Typography>
                <Box sx={{ width: "77%" }}>
                  <Select menuPlacement="auto"
                    blurInputOnSelect={false}
                    className="basic-single"
                    classNamePrefix="select"
                    value={this.state.designationOptions.find(
                      (iDesig) => iDesig.value === this.state.newdesignation
                    )}
                    isSearchable={true}
                    name="Designation"
                    menuPortalTarget={document.body}
                    styles={Constants.Styles}
                    options={this.state.designationOptions}
                    onChange={(selectedOption) =>
                      this.setState({
                        newdesignation: selectedOption.value,
                      })
                    }
                  />
                </Box>
                {this.state.showDesignationLoadSpinner ? (
                  <CircularProgress size="1em" sx={{ mt: 1.5, ml: 0.7 }} />
                ) : (
                  <Tooltip title="Reload">
                    <RefreshOutlinedIcon
                      color="primary"
                      fontSize="medium"
                      onClick={() => this.getAllDesignationList(true)}
                      sx={{ cursor: "pointer", mt: 1 }}
                    />
                  </Tooltip>
                )}
              </Box>
              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "24%", alignSelf: "center" }}>
                  Employee
                </Typography>
                <Box sx={{ width: "85%", display: "flex", alignItems: "center" }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <Select menuPlacement="auto"
                      blurInputOnSelect={false}
                      className="basic-single"
                      classNamePrefix="select"
                      isClearable
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      value={this.state.newAssignedEmployee}
                      isSearchable={true}
                      name="Employee"
                      menuPortalTarget={document.body}
                      styles={Constants.Styles}
                      options={this.state.employeeOptions}
                      onChange={(selectedOption) =>
                        this.setState({
                          newAssignedEmployee: selectedOption,
                        })
                      }
                    />
                  </Box>
                  <Tooltip title="View More Data">
                    <span style={{ cursor: "pointer", marginLeft: "8px" }}>
                      <OpenInNewIcon
                        fontSize="medium"
                        onClick={() => this.setState({ showUserDetailModal: true, userDetailContext: "E" })}
                        color="action"
                      />
                    </span>
                  </Tooltip>
                  {this.state.showEmployeeLoadSpinner ? (
                    <CircularProgress size="1em" sx={{ mt: "3px", ml: 0.7 }} />
                  ) : (
                    <Tooltip title="Reload">
                      <RefreshOutlinedIcon
                        color="primary"
                        fontSize="medium"
                        onClick={() => this.getAllEmployee(true)}
                        sx={{ cursor: "pointer", mt: "3px" }}
                      />
                    </Tooltip>
                  )}
                </Box>
              </Box>
              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "23%", alignSelf: "center" }}>
                  Broker
                </Typography>

                <Box sx={{ width: "81%", display: "flex", alignItems: "center" }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <MultiSelect
                      options={this.state.brokerOptions}
                      value={this.state.newAssignedBroker}
                      onChange={(e) => this.setState({ newAssignedBroker: e })}
                      label={"All Brokers"}
                    />
                  </Box>
                  <Tooltip title="View More Data">
                    <span style={{ cursor: "pointer", marginLeft: "8px" }}>
                      <OpenInNewIcon
                        fontSize="medium"
                        onClick={() => this.setState({ showUserDetailModal: true, userDetailContext: "B" })}
                        color="action"
                      />
                    </span>
                  </Tooltip>
                  {this.state.showBrokerLoadSpinner ? (
                    <CircularProgress size="1em" sx={{ mt: "3px", ml: 0.7 }} />
                  ) : (
                    <Tooltip title="Reload">
                      <RefreshOutlinedIcon
                        color="primary"
                        fontSize="medium"
                        onClick={() => this.getAllBroker(true)}
                        sx={{ cursor: "pointer", mt: "3px" }}
                      />
                    </Tooltip>
                  )}
                </Box>
              </Box>
              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "23%", alignSelf: "center" }}>
                  Location
                </Typography>

                <Box sx={{ width: "77%" }}>
                  <Select menuPlacement="auto"
                    blurInputOnSelect={false}
                    className="basic-single"
                    classNamePrefix="select"
                    value={this.state.newfullLocation}
                    isSearchable={true}
                    name="Location"
                    options={this.state.fullLocationOptions}
                    onChange={(selectedOption) =>
                      this.setState({ newfullLocation: selectedOption })
                    }
                    menuPortalTarget={document.body}
                    styles={Constants.Styles}
                  />
                </Box>

                {this.state.showLocationLoadSpinner ? (
                  <CircularProgress size="1em" sx={{ mt: 1.5, ml: 0.7 }} />
                ) : (
                  <Tooltip title="Reload">
                    <RefreshOutlinedIcon
                      color="primary"
                      fontSize="medium"
                      onClick={() => this.getAllLocationList(true)}
                      sx={{ cursor: "pointer", mt: 1 }}
                    />
                  </Tooltip>
                )}
              </Box>
              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "30%" }}>Discount (%)</Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  label="Discount (%)"
                  placeholder="Enter Discount"
                  value={this.state.newDiscount}
                  onChange={(e) => {
                    this.userTypeChangeHandler(this.state.newUserType, "natural");
                    this.setState({
                      newDiscount: e.target.value,
                      discountValidationError: this.setDiscountError(e, "natural"),
                    });
                  }}
                  helperText={this.state.discountValidationError}
                  error={this.state.discountValidationError.length > 0}
                  disabled={this.state.newUserType.value === "E" || this.state.newUserType.value === "B"}
                />
              </Box>
              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "30%" }}>LabGrown Discount (%)</Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  label="LabGrown Discount (%)"
                  placeholder="Enter LabGrown Discount"
                  value={this.state.newLabgrownDiscount}
                  onChange={(e) => {
                    this.userTypeChangeHandler(this.state.newUserType, "labgrown");
                    this.setState({
                      newLabgrownDiscount: e.target.value,
                      labgrownDiscountValidationError: this.setDiscountError(e, "labgrown"),
                    });
                  }}
                  helperText={this.state.labgrownDiscountValidationError}
                  error={this.state.labgrownDiscountValidationError.length > 0}
                  disabled={this.state.newUserType.value === "E" || this.state.newUserType.value === "B"}
                />
              </Box>
              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "30%" }}>GSTIN</Typography>
                <TextField
                  fullWidth
                  size="small"
                  label="Gst No"
                  placeholder="Enter Gst number"
                  value={this.state.newGstNo}
                  onChange={(e) => {
                    this.setState({
                      newGstNo: e.target.value.replace(/[^\w\s]/gi, ""),
                    });
                  }}
                  disabled={this.state.newUserType.value === "E"}
                />
              </Box>
              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "30%" }}>PAN</Typography>
                <TextField
                  fullWidth
                  size="small"
                  label="Pan No"
                  placeholder="Enter Pan number"
                  value={this.state.newPanNo}
                  onChange={(e) => {
                    this.setState({
                      newPanNo: e.target.value.trim(),
                      newPanNoValidationError: e.target.value
                        ? "" : "Pan No can't be Empty",
                    });
                  }}
                  disabled={this.state.newUserType.value === "E"}
                  helperText={this.state.newPanNoValidationError}
                  error={this.state.newPanNoValidationError.length > 0}
                />
              </Box>
              <Box sx={{ display: "flex", mt: 1 }}>
                <Box sx={{ width: "24%" }}></Box>
                <Box>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.newdeleted}
                        onChange={(e) =>
                          this.setState({
                            newdeleted: !this.state.newdeleted,
                          })
                        }
                      />
                    }
                    label="Deleted"
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: "0.8rem",
                      },
                    }}
                  />
                </Box>
                <Box>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.newdisabled}
                        onChange={(e) =>
                          this.setState({
                            newdisabled: !this.state.newdisabled,
                          })
                        }
                      />
                    }
                    label="Disabled"
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: "0.8rem",
                      },
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Modal.Body>
          <Modal.Footer>
            {this.props.saveButton ? (
              <LoadingButton
                variant="contained"
                loading={this.props.loading}
                loadingPosition="start"
                startIcon={<SaveIcon />}
                onClick={() => this.handleSave()}
                disabled={this.buttonDisable()}
                sx={{ mr: 1 }}
              >
                Save
              </LoadingButton>
            ) : null}
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
